import { render, staticRenderFns } from "./DeleteRecurringShiftDialog.vue?vue&type=template&id=89e6080a"
import script from "./DeleteRecurringShiftDialog.vue?vue&type=script&lang=js"
export * from "./DeleteRecurringShiftDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports